import React, { forwardRef } from 'react';
import styles from './FormSelect.module.css';

const ChevronDown = () => (
    <svg
        viewBox="0 0 24 24"
        width="24"
        height="24"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={styles.arrow}
    >
        <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
);

const FormSelect = forwardRef(({
    label,
    name,
    value,
    onChange,
    options = [],
    error,
    required = false,
    placeholder = 'Select an option...',
    disabled = false,
    className = '',
    style = {},
    helpText,
    children,
    ...props
}, ref) => {
    const selectId = `select-${name}`;

    return (
        <div className={`${styles.container} ${className}`} style={style}>
            {label && (
                <label htmlFor={selectId} className={styles.label}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </label>
            )}

            <div className={styles.selectWrapper}>
                <select
                    ref={ref}
                    id={selectId}
                    name={name}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    required={required}
                    className={`${styles.select} ${error ? styles.hasError : ''}`}
                    {...props}
                >
                    {children ? (
                        children
                    ) : (
                        <>
                            <option value="">{placeholder}</option>
                            {options.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </>
                    )}
                </select>
                <ChevronDown />
            </div>

            {helpText && !error && (
                <div className={styles.helpText}>
                    {helpText}
                </div>
            )}

            {error && (
                <div className={styles.error} role="alert">
                    {error}
                </div>
            )}
        </div>
    );
});

FormSelect.displayName = 'FormSelect';

export { FormSelect };
export default FormSelect;
